// removed by extract-text-webpack-plugin
module.exports = {"vpHookFormRichTextContainer":"vpHookFormRichTextContainer___2knTj","vpLoaderContainer":"vpLoaderContainer___1T441","vpHookFormRichTextError":"vpHookFormRichTextError___1U2ph","vpHookFormRichTextSubLabel":"vpHookFormRichTextSubLabel___37c2C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HookFormInputs/HookFormRichText.module.less
// module id = 2859
// module chunks = 29